<!--
 * @Name: gameRegulations
 * @Description: 文件规范
 * @Author: xiadongxue
 * @Date: 2022-04-18 17:25:27
 * @Editors: xiadongxue
-->
<template lang="pug">
  div.gameRegulations-wrap
    div.style1 {{$t('doc1')}}
    div.style2 {{$t('doc1-1')}}
    ol.style3
        li {{$t('doc1-1-1')}}
        li {{$t('doc1-1-2')}}
        li {{$t('doc1-1-3')}}
        li {{$t('doc1-1-4')}}
    div.style2 {{$t('doc1-2')}}
    ol.style3 
        li {{$t('doc1-2-1')}}
        li {{$t('doc1-2-2')}}
        li {{$t('doc1-2-3')}}
    div.style1 {{$t('doc2')}}
    div.style2 {{$t('doc2-1')}}
    ol.style3
        li {{$t('doc2-1-1')}}
    div.style2 {{$t('doc2-2')}}
    ol.style3
        li {{$t('doc2-2-1')}}
        li {{$t('doc2-2-2')}}
    div.style2 {{$t('doc2-3')}}
    ol.style3
        li {{$t('doc2-3-1')}}
    div.style2 {{$t('doc2-4')}}
    ol.style3
        li {{$t('doc2-4-1')}}
    div.style2.p-b10  {{$t('doc2-5')}}

    div.style1 {{$t('doc3')}}
    div.style2 {{$t('doc3-1')}}
    ol.style3
        li {{$t('doc3-1-1')}}
    div.style2 {{$t('doc3-2')}}
    ol.style3
        li {{$t('doc3-2-1')}}
    div.style2 {{$t('doc3-3')}}
    ol.style3
        li {{$t('doc3-3-1')}}

    div.style1 {{$t('doc4')}}
    div.style2 {{$t('doc4-1')}}
    ol.style3
        li {{$t('doc4-1-1')}}
    div.style2 {{$t('doc4-2')}}
    ol.style3
        li {{$t('doc4-2-1')}}
        li {{$t('doc4-2-2')}}
    div(v-if="$t('doc5')")
        div.style1 {{$t('doc5') || ''}}
        div.style2 {{$t('doc5-1') || ''}}
        div.style2 {{$t('doc5-2') || ''}}
        div.style2 {{$t('doc5-3') || ''}}
        div.style2 {{$t('doc5-4') || ''}}
    
    div.style1 {{$t('doc6')}}
    div.style2.style4 {{$t('doc6-1')}}
    div.style3 {{$t('doc6-1-1')}}
    div.style3 {{$t('doc6-2')}}
    div.style3 {{$t('doc6-3')}}
    div.style3 {{$t('doc6-4')}}
    div.style3 {{$t('doc6-5')}}
    div.style3 {{$t('doc7-1')}}
    
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "gameRegulations",
  computed: {
    ...mapGetters(["lang"]),
  },
};
</script>
<style lang="scss">
.gameRegulations-wrap {
  padding: 0 10px;
  .style1,
  .style2,
  .style3 {
    line-height: 1.5;
  }
  .p-b10 {
    padding-bottom: 10px;
  }
  .style1 {
    font-size: 14px;
    font-weight: bold;
  }
  .style2 {
    font-size: 12px;
    color: #ee0a24;
    padding-top: 5px;
  }
  .style3 {
    font-size: 12px;
    padding-bottom: 10px;
    li {
      background-image: url("../../assets/li_bg.png");
      text-indent: 18px;
      background-repeat: no-repeat;
      background-size: 16px auto;
    }
  }
  .style4 {
    color: #6d3d91;
  }
}
</style>
